/*
  This file contains the naming of all the apps used.

  NOTE: please be careful when editing this file. There's no source
  of authority for the apps. Please always ensure all changes to this file are
  consistent with how the development and production servers are configured.
*/

let currentApp = null;

const getCurrentApp = () => currentApp;

const setCurrentApp = (appName) => {
  currentApp = appName;
};

const apps = {
  HOME: 'home',
  CHECKOUT: 'checkout',
  STATIC_PAGES: 'static-pages',
};

export {
  apps,
  getCurrentApp,
  setCurrentApp,
};



// WEBPACK FOOTER //
// ./src/config/apps.js